import React from 'react';
import {Button} from "../button/Button";
import {Link} from "../link/Link";
import {connect} from 'react-redux';
import joinPath from 'path.join';

class ProductContainer extends React.Component {

  constructor(props) {
    super(props);

    this.state = {};

    this.findProductSolution = this.findProductSolution.bind(this);
  }

  componentDidMount(){
    this.findProductSolution(this.props);
  }

  findProductSolution(props){
    if( Array.isArray(props.solutions) && Array.isArray(props.product_categories) ) {
      const solution = props.solutions.find(s => props.product_categories.includes(s.id));
      if (solution) {
        this.setState({
          solution_slug: solution.slug
        });
      }
    }
  }

  componentWillReceiveProps(nextProps){
    this.findProductSolution(nextProps);
  }

  render(){

    let productImage;
    let productText;
    let datasheet = null;

    try {
      const image = this.props._embedded["wp:featuredmedia"][0];

      if(image){
        productImage = <img width={ image.media_details.width }
                            height={ image.media_details.height }
                            src={ image.source_url || require('../../assets/images/empty.png')}
                            alt={image.alt_text}/>;
      } else {
        productImage = null;
      }
    } catch(e){}

    try {
      productText = this.props.acf.obx_product_description;
    } catch(e){}

    try {
      datasheet = this.props.acf.obx_product_datasheet;
    } catch(e){}

    if(!this.props.title)
      return null;

    return (
      <Link to={ joinPath("/solutions/", this.state.solution_slug || '', "/products/", this.props.slug) }
            className={"product-link"}
            tag={"div"}>
        <div className={"product-container " + this.props.itemStyle}>
          { productImage }
          <div className={"product-content"}>
            <h2>{ this.props.title.rendered }</h2>
            <p className={"product-content-body"}>
              { productText }
              </p>
          </div>
          {
            Boolean(datasheet) &&
            <a href={datasheet.url}
               target="_blank"
               rel="noopener noreferrer"
               className={"product-buttons"}
               onClick={event => event.stopPropagation()}>
              <Button color="secondary" className="datasheet-button">Datasheet</Button>
            </a>
          }
        </div>
      </Link>
    );
  }
}

export const Product = connect(
  state => ({
    location: state.router.location,
    solutions: ( state.resolve.data && state.resolve.data.solutions ) || []
  })
)(ProductContainer);



// WEBPACK FOOTER //
// ./src/components/item/Product.js